export const default_playlists = [
    {
        "description": "Your weekly update of the most played tracks right now - Global.",
        "id": "37i9dQZEVXbNG2KDcFcKOF",
        "images": [
            {
                "height": null,
                "url": "https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_global_large.jpg",
                "width": null
            }
        ],
        "name": "Top Songs - Global",
        "uri": "spotify:playlist:37i9dQZEVXbNG2KDcFcKOF"
    },
    {
        "description": "Your weekly update of the most played tracks right now - Indonesia.",
        "id": "37i9dQZEVXbIZK8aUquyx8",
        "images": [
            {
                "height": null,
                "url": "https://charts-images.scdn.co/assets/locale_en/regional/weekly/region_id_large.jpg",
                "width": null
            }
        ],
        "name": "Top Songs - Indonesia",
        "uri": "spotify:playlist:37i9dQZEVXbIZK8aUquyx8"
    },
    {
        "description": "The pulse of R&B music today.  Cover: Kiana Ledé",
        "id": "37i9dQZF1DX4SBhb3fqCJd",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706f000000036e00d016ff63dbcd0458a4bc",
                "width": null
            }
        ],
        "name": "Are & Be",
        "uri": "spotify:playlist:37i9dQZF1DX4SBhb3fqCJd"
    },
    {
        "description": "Jejeran lagu terfavorit dari kancah musik independen Indonesia. Cover: Daun Jatuh, Souljah",
        "id": "37i9dQZF1DXd82NU5rAcTZ",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706f00000003329465cf4eb094e9806f37b7",
                "width": null
            }
        ],
        "name": "IndieNesia",
        "uri": "spotify:playlist:37i9dQZF1DXd82NU5rAcTZ"
    },
    {
        "description": "lagu-lagu yang sering diputar waktu warnet masih jadi primadona",
        "id": "2Xhi7lIiI6XGHJHgcgp3ut",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706c0000bebb6aa03c6ffdc9ccba085273c4",
                "width": null
            }
        ],
        "name": "Playlist anak warnet 2000an",
        "uri": "spotify:playlist:2Xhi7lIiI6XGHJHgcgp3ut"
    },
    {
        "description": "Lagu Indonesia kesayangan kamu sepanjang era 2000an. Cover : Ungu",
        "id": "37i9dQZF1DX7nbWskw2fKF",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706f000000037b14a53e36eef03ba4ba5749",
                "width": null
            }
        ],
        "name": "Terbaik 2000an",
        "uri": "spotify:playlist:37i9dQZF1DX7nbWskw2fKF"
    },
    {
        "description": "Barisan rima dan ritme dari produser musik dan rapper dalam negeri. Cover: Krowbar",
        "id": "37i9dQZF1DWYJVaIADJesD",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706f00000003d125e278a73bd9c316ecad2c",
                "width": null
            }
        ],
        "name": "Hip Hop Indo",
        "uri": "spotify:playlist:37i9dQZF1DWYJVaIADJesD"
    },
    {
        "description": "Please stand for your personal anthems. Cover: My Chemical Romance",
        "id": "37i9dQZF1DXasneILDRM7B",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706f00000003ef954d00bb093060479c28ad",
                "width": null
            }
        ],
        "name": "Pure Pop Punk",
        "uri": "spotify:playlist:37i9dQZF1DXasneILDRM7B"
    },
    {
        "description": "feel it all. Cover: My Chemical Romance",
        "id": "37i9dQZF1DX9wa6XirBPv8",
        "images": [
            {
                "height": null,
                "url": "https://i.scdn.co/image/ab67706f00000003fc0dc9b786b7e9ec570b9323",
                "width": null
            }
        ],
        "name": "Emo Forever",
        "uri": "spotify:playlist:37i9dQZF1DX9wa6XirBPv8"
    },
]